'use client';

import Link from 'next/link';
import { MapPin, Home, Search, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center max-w-md">
        {/* Icon */}
        <div className="mb-6">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-blue-100 rounded-full">
            <MapPin className="w-10 h-10 text-blue-600" />
          </div>
        </div>

        {/* Error code */}
        <h1 className="text-6xl font-bold text-gray-900 mb-2">404</h1>

        {/* Title */}
        <h2 className="text-2xl font-semibold text-gray-800 mb-3">
          Page Not Found
        </h2>

        {/* Description */}
        <p className="text-gray-600 mb-8">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
          This might be because the provider or route you&apos;re searching for
          is no longer available.
        </p>

        {/* Action buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link href="/hub/">
            <Button className="w-full sm:w-auto">
              <Home className="w-4 h-4 mr-2" />
              Go to Hub
            </Button>
          </Link>
          <Link href="/providers/">
            <Button variant="outline" className="w-full sm:w-auto">
              <Search className="w-4 h-4 mr-2" />
              Browse Providers
            </Button>
          </Link>
        </div>

        {/* Back link */}
        <div className="mt-8">
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700"
          >
            <ArrowLeft className="w-4 h-4 mr-1" />
            Go back to previous page
          </button>
        </div>

        {/* Help text */}
        <p className="mt-8 text-xs text-gray-400">
          If you believe this is an error, please{' '}
          <a
            href="mailto:support@ratesagent.ai"
            className="text-blue-600 hover:underline"
          >
            contact support
          </a>
          .
        </p>
      </div>
    </div>
  );
}
